import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { UpdateVacancyDateError } from '../../errors';
import { ESubdomain } from '../../constants/domain';
import {
  fetchUpdateVacancyDate,
  IUpdateVacancyDateResponse200,
  IUpdateVacancyDateResponse400,
} from '../../repositories/vacancies/v1/update-vacancy-date';

export interface IUpdateVacancyDateDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  subdomain: ESubdomain;
}

export interface IUpdateVacancyDateParams {
  vacancyId: number;
}

export const updateVacancyDate = async (deps: IUpdateVacancyDateDependencies, params: IUpdateVacancyDateParams) => {
  const { httpApi, logger, subdomain } = deps;
  const { vacancyId } = params;

  try {
    const resp = await fetchUpdateVacancyDate<IUpdateVacancyDateResponse200, IUpdateVacancyDateResponse400>({
      httpApi,
      parameters: {
        vacancyId,
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        },
      },
    });

    if (resp.statusCode !== 200) {
      throw new UpdateVacancyDateError({
        subdomain,
        message: resp.response.message,
        details: {
          error: JSON.stringify(resp.response.errors),
        },
      });
    }
  } catch (e) {
    logger.error(e);
  }
};
